import t from "../translations";

const FrontEndLearnArray = () => t.frontEndTopics;

export default FrontEndLearnArray;
